import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ShoppingCartContext } from '../ShoppingCartContext';

const ShoppingCartDescriptionCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);

  const handleViewProductDetails = useContextSelector(
    ShoppingCartContext,
    (state) => state.handleViewProductDetails
  );
  const isFetchingProductDetails = useContextSelector(
    ShoppingCartContext,
    (state) => state.isFetchingProductDetails
  );
  const loadingProductDetails = useContextSelector(
    ShoppingCartContext,
    (state) => state.loadingProductDetails
  );
  const isDisabled = loadingProductDetails || isFetchingProductDetails;

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      <button
        type="button"
        disabled={isDisabled}
        className="w-[100%] truncate rounded text-left text-[#0E80B4] hover:underline focus:outline-2 focus:outline-black"
        onClick={(e) => handleViewProductDetails(e, props.dataItem)}
      >
        {value}
      </button>
    </GridCellBase>
  );
};

export default ShoppingCartDescriptionCell;
